import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SupplierReportService {


  constructor(private http: HttpClient) { }

  url = environment.serverAPI5 + "/api/supplierreport";

  ur2 = environment.serverAPI5 + "/api/supplierPurchaseReport";

  ur3 = environment.serverAPI5 + "/api/paymentNewReport";

  searchSupplierreport(query: string, page: number, size: number, sort: string, groupBy: any): Observable<Response[]> {


    const requestBody = {
      "searchQuery": query != null ? String(query).split("'").join('') : null,
      "groupBy": groupBy

    };
    const queryParams = `?page=${page}&size=${size}&sort=${sort}`; // Construct query parameters

    return this.http.post<Response[]>(`${this.url}/condition${queryParams}`, requestBody);
  }

  searchSupplierPurchasereport(id: number, query: string, page: number, size: number, sort: string, groupBy: any): Observable<Response[]> {


    const requestBody = {
      "searchQuery": query != null ? String(query).split("'").join('') : null,
      "groupBy": groupBy

    };
    const queryParams = `?page=${page}&size=${size}&sort=${sort}`;

    return this.http.post<Response[]>(`${this.ur2}/condition/${id}${queryParams}`, requestBody);
  }

  searchPaymentNewReport(id: number, query: string, page: number, size: number, sort: string, groupBy: any): Observable<Response[]> {


    const requestBody = {
      "searchQuery": query != null ? String(query).split("'").join('') : null,
      "groupBy": groupBy

    };
    const queryParams = `?page=${page}&size=${size}&sort=${sort}`;

    return this.http.post<Response[]>(`${this.ur3}/condition/${id}${queryParams}`, requestBody);
  }

  downloadapproveTransactions(): Observable<any> {
    return this.http.get(`${this.url}/export`, { responseType: 'arraybuffer', observe: 'response' });
  }

  getapproveTransactions(Page: number, size: number, sort: number): Observable<Object> {
    return this.http.get(`${this.url}?page=${Page}&size=${size}&sort=${sort}`);
  }
}
